import React from 'react';
import { IContent } from '../../../types';
import { withContent } from '../../../hoc/withContext';
import './FranchisesBlock.scss';

// @ts-ignore
import Slider from "react-slick";

import PrevArrow from '../../Elements/Sliders/PrevArrow';
import NextArrow from '../../Elements/Sliders/NextArrow';
import sliderConfig from './sliderConfig';

import FranchiseElement from '../../Elements/Franchise/FranchiseElement';
import Title from '../../Elements/Title/TitleElement';

interface IFranchisesBlockProps {
  context?: IContent;
}

const FranchisesBlock = ({ context }: IFranchisesBlockProps) => {
  const { franchises } = context;
  const { items, is_active, title } = franchises;

  const filteredFranchises = items.filter((item: any) => item.title && item.image && item.link);

  return is_active && (
    <div className="block-container-franchises">
      <Title>{title}</Title>
      {filteredFranchises.length > 0 && (
        <Slider
          className={`block-franchises`}
          prevArrow={(<PrevArrow />)}
          nextArrow={(<NextArrow />)}
          {...sliderConfig}
        >
          {filteredFranchises.map((item: any) => (
            <FranchiseElement key={item.title} item={item} />
          ))}
        </Slider>
      )}
    </div>
  );
};

export default withContent(FranchisesBlock);
